(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["labels-brand-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-brand-launch')) {
  customElements.define('lb-brand-launch', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.effect = this.dataset.effect;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // In the theme editor everything is shown immediately so settings changes are visible
      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      if (!this.designMode) this.classList.add('is-js');
      this.initReveal();
      this.initCountdown();
      if (this.effect !== 'none' && !this.reduced) this.initScroll();
    }
    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.io) this.io.disconnect();
      if (this.rv) this.rv.disconnect();
      clearInterval(this.timer);
    }

    /* scroll-driven reveal: --pa (reveal), --pf (intro fade), --pc (content) */
    initScroll() {
      const seg = (p, a, b) => Math.min(1, Math.max(0, (p - a) / (b - a)));
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const curtain = this.effect === 'curtain';
      let ticking = false;
      const update = () => {
        ticking = false;
        const r = this.track.getBoundingClientRect();
        const total = r.height - window.innerHeight;
        const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        this.style.setProperty('--pa', ease(seg(p, 0.04, 0.62)).toFixed(4));
        this.style.setProperty('--pf', (curtain ? seg(p, 0.02, 0.32) : seg(p, 0.38, 0.66)).toFixed(4));
        this.style.setProperty('--pc', ease(seg(p, 0.55, 0.86)).toFixed(4));
      };
      this.onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      this.onResize = this.onScroll;
      this.io = new IntersectionObserver((entries) => {
        const visible = entries.some((e) => e.isIntersecting);
        if (visible) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          update();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }, { rootMargin: '200px 0px' });
      this.io.observe(this.track);
      update();
    }

    /* fade-up for editorial + products */
    initReveal() {
      const items = this.querySelectorAll('.lb-bl__rv');
      if (!items.length) return;
      if (this.reduced || !('IntersectionObserver' in window)) { items.forEach((i) => i.classList.add('is-in')); return; }
      this.rv = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); this.rv.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      items.forEach((i) => this.rv.observe(i));
    }

    /* launch date in Dutch time: "2026-10-24 10:00" */
    launchTime() {
      const m = (this.dataset.launch || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      if (!m) return null;
      const utcGuess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(utcGuess));
      const g = (t) => +parts.find((p) => p.type === t).value;
      const asAms = Date.UTC(g('year'), g('month') - 1, g('day'), g('hour'), g('minute'));
      return utcGuess - (asAms - utcGuess);
    }
    initCountdown() {
      const status = this.querySelector('[data-status]');
      const liveCtas = this.querySelector('[data-live-ctas]');
      const preCtas = this.querySelector('[data-pre-ctas]');
      const target = this.launchTime();
      if (!status || target === null) return;
      const pre = status.querySelector('[data-pre]');
      const live = status.querySelector('[data-live]');
      const u = {};
      status.querySelectorAll('[data-u]').forEach((el) => { u[el.dataset.u] = el; });
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = target - Date.now();
        const isPre = diff > 0;
        pre.hidden = !isPre;
        live.hidden = isPre;
        if (preCtas) { preCtas.hidden = !isPre; if (liveCtas) liveCtas.hidden = isPre; }
        if (isPre) {
          const s = Math.floor(diff / 1000);
          u.d.textContent = pad(Math.floor(s / 86400));
          u.h.textContent = pad(Math.floor((s % 86400) / 3600));
          u.m.textContent = pad(Math.floor((s % 3600) / 60));
          u.s.textContent = pad(s % 60);
        } else {
          clearInterval(this.timer);
        }
        status.hidden = false;
      };
      tick();
      this.timer = setInterval(tick, 1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labels-designers-az"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-designers-az')) {
  customElements.define('lb-designers-az', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-az-search]');
      const empty = this.querySelector('[data-az-empty]');
      if (!input) return;
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        let shown = 0;
        this.querySelectorAll('[data-az-group]').forEach((g) => {
          let n = 0;
          g.querySelectorAll('[data-az-name]').forEach((li) => {
            const hit = !q || li.dataset.azName.includes(q);
            li.hidden = !hit;
            if (hit) n++;
          });
          g.hidden = n === 0;
          shown += n;
        });
        empty.hidden = shown > 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labels-designers-index"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-designers-v2')) {
  customElements.define('lb-designers-v2', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t) => t.addEventListener('click', () => this.selectGender(t.dataset.g)));
      this.addEventListener('keydown', (e) => {
        if (!e.target.matches('[role="tab"]') || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const i = this.tabs.indexOf(e.target);
        const next = this.tabs[(i + 1) % this.tabs.length];
        next.focus();
        this.selectGender(next.dataset.g);
      });
      // Preload the images of the visible tab before the section scrolls into view,
      // and the other tab's images as soon as someone points at / focuses that tab.
      this.tabs.forEach((t) => {
        t.addEventListener('pointerenter', () => this.preload(t.dataset.g));
        t.addEventListener('focus', () => this.preload(t.dataset.g));
      });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          const active = this.querySelector('.lb-des2__panel:not([hidden])');
          if (active) this.preload(active.dataset.g);
          io.disconnect();
        }, { rootMargin: '1200px 0px' });
        io.observe(this);
      } else {
        this.tabs.forEach((t) => this.preload(t.dataset.g));
      }
      this.initAllDesigners();
      this.querySelectorAll('.lb-des2__panel').forEach((panel) => {
        panel.querySelectorAll('.lb-des2__link').forEach((a) => {
          const go = () => this.activate(panel, a.dataset.i);
          a.addEventListener('mouseenter', go);
          a.addEventListener('focus', go);
        });
      });
    }
    initAllDesigners() {
      this.querySelectorAll('[data-all-open]').forEach((btn) => {
        const dialog = this.querySelector(`[data-all-dialog="${btn.dataset.allOpen}"]`);
        if (!dialog) return;
        btn.addEventListener('click', () => {
          dialog.showModal();
          document.documentElement.classList.add('lb-modal-open');
        });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('lb-modal-open');
          btn.focus();
        });
        dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
        dialog.querySelector('[data-all-close]').addEventListener('click', () => dialog.close());
      });
    }
    preload(g) {
      const panel = this.querySelector(`.lb-des2__panel[data-g="${g}"]`);
      if (!panel || panel.dataset.preloaded) return;
      panel.dataset.preloaded = '1';
      const sel = window.matchMedia('(min-width: 750px)').matches ? '.lb-des2__slide-img' : '.lb-des2__card-img';
      panel.querySelectorAll(sel).forEach((img) => { img.loading = 'eager'; });
    }
    selectGender(g) {
      this.preload(g);
      this.tabs.forEach((t) => {
        const on = t.dataset.g === g;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('.lb-des2__panel').forEach((p) => {
        p.hidden = p.dataset.g !== g;
        if (!p.hidden) this.activate(p, '0');
      });
    }
    activate(panel, i) {
      panel.querySelectorAll('.lb-des2__slide').forEach((s) => s.classList.toggle('is-active', s.dataset.i === i));
      panel.querySelectorAll('.lb-des2__link').forEach((a) => a.classList.toggle('is-active', a.dataset.i === i));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labels-product-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-product-tabs')) {
  customElements.define('lb-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.tab)));
      this.addEventListener('keydown', (e) => {
        if (!e.target.matches('[role="tab"]') || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const i = this.tabs.indexOf(e.target);
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        this.select(next.dataset.tab);
      });
      this.querySelectorAll('.lb-tabs__arrow').forEach((b) => b.addEventListener('click', () => {
        const track = this.activeTrack();
        if (track) track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth, behavior: 'smooth' });
      }));
      this.querySelectorAll('.lb-tabs__track').forEach((t) => t.addEventListener('scroll', () => this.updateArrows(), { passive: true }));
      this.updateArrows();
    }
    activeTrack() {
      const p = this.querySelector('[data-panel]:not([hidden])');
      return p && p.querySelector('.lb-tabs__track');
    }
    select(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== id; });
      this.querySelectorAll('[data-viewall]').forEach((a) => { a.hidden = a.dataset.viewall !== id; });
      this.updateArrows();
    }
    updateArrows() {
      const t = this.activeTrack();
      const [prev, next] = this.querySelectorAll('.lb-tabs__arrow');
      if (!t || !prev) return;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labels-split-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-split-hero')) {
  customElements.define('lb-split-hero', class extends HTMLElement {
    connectedCallback() {
      this.startSlides();
      this.track = this.querySelector('[data-hero-track]');
      this.btns = [...this.querySelectorAll('.lb-hero__switch-btn')];
      if (!this.track || this.btns.length < 2) return;
      this.mq = window.matchMedia('(max-width: 749px)');
      this.btns.forEach((b) => b.addEventListener('click', () => {
        this.touched = true;
        this.go(Number(b.dataset.index));
      }));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.track.addEventListener('pointerdown', () => { this.touched = true; }, { passive: true });
      this.nudgeOnce();
    }
    // Crossfade up to 3 images per panel; panels run half an interval apart
    startSlides() {
      const interval = Number(this.dataset.interval || 6) * 1000;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.querySelectorAll('[data-hero-slides]').forEach((wrap) => {
        const slides = [...wrap.querySelectorAll('.lb-hero__slide')];
        if (slides.length < 2) return;
        let i = 0;
        const tick = () => {
          if (document.hidden) return;
          slides[i].classList.remove('is-active');
          i = (i + 1) % slides.length;
          const img = slides[i].querySelector('img');
          if (img) img.loading = 'eager';
          slides[i].classList.add('is-active');
        };
        // preload the next image a bit before it is needed
        const next = slides[1].querySelector('img');
        if (next) setTimeout(() => { next.loading = 'eager'; }, Math.max(0, interval - 2500));
        setTimeout(() => setInterval(tick, interval), Number(wrap.dataset.offset) * (interval / 2));
      });
    }
    go(i) {
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.reduced() ? 'auto' : 'smooth' });
    }
    sync() {
      const i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
      this.btns.forEach((b, n) => b.setAttribute('aria-pressed', String(n === i)));
    }
    reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    // One subtle peek at the next panel the first time the hero is seen on mobile
    nudgeOnce() {
      if (!this.mq.matches || this.reduced() || !('IntersectionObserver' in window)) return;
      try { if (sessionStorage.getItem('lbHeroNudged')) return; } catch (e) {}
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        setTimeout(() => {
          if (this.touched || this.track.scrollLeft > 0) return;
          const snap = this.track.style.scrollSnapType;
          this.track.style.scrollSnapType = 'none';
          this.track.scrollTo({ left: Math.min(72, this.track.clientWidth * 0.18), behavior: 'smooth' });
          setTimeout(() => {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(() => { this.track.style.scrollSnapType = snap; }, 500);
          }, 650);
          try { sessionStorage.setItem('lbHeroNudged', '1'); } catch (e) {}
        }, 1200);
      }, { threshold: 0.6 });
      io.observe(this.track);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labels-store-visit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lb-store-visit')) {
  customElements.define('lb-store-visit', class extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('[data-dialog]');
      const opener = this.querySelector('[data-open]');
      const close = () => dialog.close();
      opener.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('lb-modal-open');
        this.renderStatus();
      });
      this.querySelector('[data-close]').addEventListener('click', close);
      // click on the backdrop closes
      dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('lb-modal-open');
        opener.focus();
      });

      // Route: Apple Maps on iOS/iPadOS, Google Maps elsewhere
      const route = this.querySelector('[data-route]');
      const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (route && isApple) route.href = `https://maps.apple.com/?daddr=${route.dataset.query}`;

      // Copy address
      const copy = this.querySelector('[data-copy]');
      if (copy) copy.addEventListener('click', async () => {
        const label = copy.querySelector('[data-copy-text]');
        const original = label.textContent;
        try { await navigator.clipboard.writeText(copy.dataset.copy); label.textContent = 'Copied'; }
        catch (e) { label.textContent = copy.dataset.copy; }
        setTimeout(() => { label.textContent = original; }, 2000);
      });

      this.renderStatus();
      this.timer = setInterval(() => this.renderStatus(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }

    // Current day (1 = Monday) and minutes since midnight in the store's time zone
    now() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const get = (t) => parts.find((p) => p.type === t).value;
      const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday')) + 1;
      return { day, mins: Number(get('hour')) * 60 + Number(get('minute')) };
    }
    parse(str) {
      const m = (str || '').match(/(\d{1,2})[:.](\d{2})\s*[-–]\s*(\d{1,2})[:.](\d{2})/);
      if (!m) return null;
      return { open: +m[1] * 60 + +m[2], close: +m[3] * 60 + +m[4], openText: `${m[1].padStart(2, '0')}:${m[2]}`, closeText: `${m[3].padStart(2, '0')}:${m[4]}` };
    }
    renderStatus() {
      const statuses = [...this.querySelectorAll('[data-status]')];
      const rows = [...this.querySelectorAll('tr[data-day]')];
      if (!statuses.length || !rows.length) return;
      const hours = {};
      rows.forEach((r) => { hours[r.dataset.day] = this.parse(r.dataset.hours); });
      const { day, mins } = this.now();
      rows.forEach((r) => r.classList.toggle('is-today', Number(r.dataset.day) === day));

      const today = hours[day];
      let text;
      let open = false;
      if (today && mins >= today.open && mins < today.close) {
        open = true;
        text = mins >= today.close - 60 ? `Open now · closes at ${today.closeText}` : `Open now · until ${today.closeText}`;
      } else if (today && mins < today.open) {
        text = `Closed · opens today at ${today.openText}`;
      } else {
        const names = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
        for (let i = 1; i <= 7; i++) {
          const d = ((day - 1 + i) % 7) + 1;
          if (hours[d]) { text = `Closed · opens ${i === 1 ? 'tomorrow' : names[d]} at ${hours[d].openText}`; break; }
        }
      }
      if (!text) return;
      statuses.forEach((status) => {
        status.querySelector('[data-status-text]').textContent = text;
        status.classList.toggle('is-open', open);
        status.hidden = false;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
